import { companyAPI } from '@/services-ts/axios'
import type { IPayloadCompanyValue, IPayloadCompanyValueGroup } from '@/types/Request'
import type { ICompanyValueStore } from '@/types/Store/State'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'
import { useFilterStore } from '../'

export const useCompanyValueStore = defineStore('companyValue', {
  state: (): ICompanyValueStore => ({
    companyValueList: [],
    valueGroupList: [],
  }),

  actions: {
    async GetCompanyValueList() {
      const payload = {
        Id: null,
        Skip: 0,
        Take: 9999,
      }

      const { status, data } = await companyAPI.CompanyServices.GetCompanyValueList(payload)
      this.companyValueList = status ? data : []
    },

    async CreateCompanyValue(payload: IPayloadCompanyValue) {
      const { status, data } = await companyAPI.CompanyServices.CreateCompanyValue(payload)

      if (status) {
        this.companyValueList.push(data)

        void Alert({
          message: Format('admin_global_success'),
          type: 'success',
        })
      }
      return status
    },

    async UpdateCompanyValue(payload: IPayloadCompanyValue) {
      const { status, data } = await companyAPI.CompanyServices.UpdateCompanyValue(payload)

      if (status) {
        const index = this.companyValueList.findIndex(x => x.id === payload.Id)
        this.companyValueList[index] = data

        void Alert({
          message: Format('admin_global_success'),
          type: 'success',
        })
      }

      return status
    },

    async DeleteCompanyValue(Id: string) {
      const { status } = await companyAPI.CompanyServices.DeleteCompanyValue(Id)

      if (status) {
        this.companyValueList = this.companyValueList.filter(x => x.id !== Id)
        void Alert({
          message: Format('admin_global_success'),
          type: 'success',
        })
      }
    },

    async GetCompanyValueGroupList() {
      const payload = {
        Skip: 0,
        Take: 9999,
      }
      const { status, data } = await companyAPI.CompanyServices.GetCompanyValueGroupList(payload)
      this.valueGroupList = status ? data : []
    },

    async CreateCompanyValueGroup(payload: IPayloadCompanyValueGroup) {
      const { status, data, message } =
        await companyAPI.CompanyServices.CreateCompanyValueGroup(payload)

      if (status) {
        data.filterName =
          useFilterStore().filterList.data.find(x => x.id === data.filterId)?.name || ''
        this.valueGroupList.push(data)
        this.valueGroupList.sort((a, b) => a.name.localeCompare(b.name))

        void Alert({
          message: Format('admin_global_success'),
          type: 'success',
        })
      } else {
        void Alert({
          message: message || Format('admin_global_error'),
          type: 'danger',
        })
      }
      return status
    },

    async UpdateCompanyValueGroup(payload: IPayloadCompanyValueGroup) {
      const { status, data } = await companyAPI.CompanyServices.UpdateCompanyValueGroup(payload)

      if (status) {
        const index = this.valueGroupList.findIndex(x => x.id === payload.Id)
        this.valueGroupList[index] = data
        this.valueGroupList[index].filterName =
          useFilterStore().filterList.data.find(x => x.id === payload.FilterId)?.name || ''
        this.valueGroupList.sort((a, b) => a.name.localeCompare(b.name))
        void Alert({
          message: Format('admin_global_success'),
          type: 'success',
        })
      }
      return status
    },

    async DeleteCompanyValueGroup(Id: string) {
      const { status } = await companyAPI.CompanyServices.DeleteCompanyValueGroup(Id)

      if (status) {
        this.valueGroupList = this.valueGroupList.filter(x => x.id !== Id)
        void Alert({
          message: Format('admin_global_success'),
          type: 'success',
        })
      }
      return status
    },
  },
})
